<div class="filter-menu" *ngIf="filter.filterMenuVisible">
    <div class="filter-container">
      <div class="filter-header">
        <div class="adc-iptgrp-top" *ngIf="filter.type == 'text'">
          <input
            type="text"
            class="adc-form-control-icon-right-1"
            autofocus
            placeholder="Filter by..."
            (keyup.enter)="applyFilter($event)"
          />
  
        </div>
        <div *ngIf="filter.type == 'date'"
          class="adc-iptgrp-top adc-mb15"
          class="date-ipt"
        >
          <label for="from">From</label>
          <input type="date" [(ngModel)]="fromDateValue" />
          <label for="to">To</label>
          <input type="date" [(ngModel)]="toDateValue" (change)="apply()" />
        </div>
      </div>
  
      <div *ngIf="filteredData">
        <div class="select-all-none">
          <!-- <span
            class="material-symbols-outlined"
            title="Select All"
            (click)="selectAll()"
            >library_add_check</span
          >
          <span
            class="material-symbols-outlined"
            title="Clear All"
            (click)="clearSelectedValues()"
            >remove_selection</span
          > -->
          <div class="adc-chk">
            <label for="check">Select All</label>
            <input type="checkbox" id="check" class="adc-m0" value="" (click)="$event.stopPropagation()" (change)="selectAndDeselectAll($event)">
          </div>
        </div>
  
        <div class="columns-list">
          <div class="adc-chkgrp-vr">
            <div class="adc-chk" *ngFor="let data of filteredData">
              <input
                type="checkbox"
                [(ngModel)]="data.selected"
                id="{{ data.id }}"
                (change)="updateSelectedValues(data)"
              />
              <label
                for="{{ data.id }}"
                class="selected-label"
                title="{{ data.value }}"
                >{{ data.value }}</label
              >
            </div>
          </div>
        </div>
      </div>
  
      <div *ngIf="filter.type == 'list'">
        <div
        class="selected-list adc-d-flex adc-gap-2 adc-align-items-center adc-flex-wrap"
      >
        <!-- Selected Filters Display -->
        <span class="adc-tag-icon-right"
          *ngFor="let selectedValue of selectedValues; let i = index"
        >
          <span
            class="adc-tooltip selected-value"
            data-position="bottom"
            title="{{ selectedValue }}"
            >{{ selectedValue }}</span
          >
          <!-- <span class="remove-icon material-symbols-outlined" (click)="removeSelectedValue(selectedValue)">close</span> -->
          <mat-icon (click)="removeSelectedValue(selectedValue)">close</mat-icon>
        </span>
      </div>
      </div>
      <!-- <hr>
          <div class="adc-d-flex adc-justify-content-between adc-align-items-center adc-mt15">
            <button class="adc-btn adc-btn-outline-primary adc-btn-sm" (click)="cancel()">Cancel</button>
            <button class="adc-btn adc-btn-primary adc-btn-sm" (click)="apply()">Apply</button>
          </div> -->
      <div class="adc-d-flex adc-justify-content-between adc-align-items-center adc-mt15">
        <button class="adc-btn adc-btn-outline-primary adc-btn-sm" (click)="cancel()">Cancel</button>
        <button class="adc-btn adc-btn-primary adc-btn-sm" (click)="apply()">Apply</button>
      </div>
    </div>
  </div>
  